import React, { ReactNode } from 'react'
import * as styles from './form.styles'

interface FormProps{
    children:ReactNode,
    title?: string,
    subtitle?:string,
    className?:string
}
const Form = ({ children, title, subtitle, className }: FormProps) => {
    return (
        <form className={`${styles.formContainer}`}>
            <div className={styles.titleDiv}>
                <p className={styles.title}>{title}</p>
                <p className={styles.subtitle}>{subtitle}</p>
            </div>
            {children}
        </form>
    )
}

export default Form